export default __webpack_public_path__ + "static/media/1.7dadce64.jpg";